import { Patch } from "rfc6902";
import IErrorInfo from "../models/account/IErrorInfo";
import IAuctionDetail from "../models/auction/IAuctionDetail";
import ICreateUpdateAuction from "../models/auction/ICreateUpdateAuction";
import ICurrentAuctionState from "../models/auction/ICurrentAuctionState";
import { RoleParcelState } from "../models/auction/RoleParcelState";
import HttpProvider from "../providers/HttpProvider";

export default class AuctionApi {
    public static async GetAuction(
        url: string
    ): Promise<IAuctionDetail | null> {
        const uriStr = `${this.apiUrl}/get-auction`;
        const queryParams = { url };

        const response = await HttpProvider.GetRequest(uriStr, queryParams);
        if (!response.ok) {
            return null;
        }

        return (await response.json()) as IAuctionDetail;
    }

    public static async GetParcelStates(
        auctionId: string,
        currentState: ICurrentAuctionState[]
    ): Promise<RoleParcelState[]> {
        const uriStr = `${this.apiUrl}/auction-live-info/${auctionId}`;
        const response = await HttpProvider.PostRequest(uriStr, currentState);

        if (!response.ok) {
            return [];
        }

        return (await response.json()) as RoleParcelState[];
    }

    public static async CreateAuction(
        newAuction: ICreateUpdateAuction
    ): Promise<IErrorInfo[]> {
        const uriStr = `${this.apiUrl}/create`;
        const response = await HttpProvider.PostRequest(uriStr, newAuction);
        if (!response.ok) {
            return (await response.json()) as IErrorInfo[];
        }

        return [];
    }

    public static async UpdateAuction(
        id: string,
        auctionPatch: Patch
    ): Promise<IErrorInfo[]> {
        const uriStr = `${this.apiUrl}/update/${id}`;
        const response = await HttpProvider.JsonPatchRequest(
            uriStr,
            auctionPatch
        );
        if (!response.ok) {
            return (await response.json()) as IErrorInfo[];
        }

        return [];
    }

    public static async DeleteAuction(id: string): Promise<IErrorInfo[]> {
        const uriStr = `${this.apiUrl}/delete/${id}`;
        const response = await HttpProvider.DeleteRequest(uriStr);
        if (!response.ok) {
            return (await response.json()) as IErrorInfo[];
        }

        return [];
    }

    public static async SyncSalesSite(id: string): Promise<IErrorInfo[]> {
        const uriStr = `${this.apiUrl}/sync-sales-site/${id}`;
        const response = await HttpProvider.PostRequest(uriStr);
        if (!response.ok) {
            return [
                {
                    description:
                        "Error syncing sales site, please try again later.",
                    code: ""
                }
            ];
        }

        return [];
    }

    private static readonly apiUrl = "/api/auction";
}
